import { useI18n } from 'i18n-utils'
import { SpotOrderTabType, useKlineStore, useSpotOrderListStore } from 'store'
import { CurrentOrderList } from './CurrentOrderList'

import { TabPane, Tabs } from '@/components/Tabs'
import { getUserCenterPageRoute, UserCenterRoutes } from '@/constants/PageRoutes'
import { ElCheckbox } from 'element-plus'
import { useChangeLanguage } from 'store'
import { LazyLoadingComponent, RecordIcon } from 'ui-components'
import '../styles/order-list-layout.scss'
import { PositionList } from './PositionList'

export const OrderList = defineComponent({
  setup() {
    const spotOrderListStore = useSpotOrderListStore()
    const { t } = useI18n()
    const router = useRouter()
    const klineStore = useKlineStore()
    onBeforeRouteLeave(() => {
      spotOrderListStore.stopGetCurrentOrderList()
    })

    useChangeLanguage(async () => {
      await spotOrderListStore.getCurrentOrderList()
    })

    const onRecord = () => {
      router.push({
        path: getUserCenterPageRoute(UserCenterRoutes.SpotOrder),
      })
    }

    onBeforeUnmount(() => {
      spotOrderListStore.$dispose()
    })

    return () => (
      <div class="spot-order-list-layout">
        <div class="header">
          <Tabs
            v-model={spotOrderListStore.activeTab}
            tabHeight={40}
            lineWidth={16}
            tabNavHeight={'auto'}
            headerRight={() => (
              <div class="filter-container">
                {spotOrderListStore.activeTab === SpotOrderTabType.Current && <ElCheckbox v-model={spotOrderListStore.hideOtherOrder}>{t('隐藏其他币种')}</ElCheckbox>}
                <RecordIcon onClick={onRecord} />
              </div>
            )}
          >
            {spotOrderListStore.tabs.map((tab) => {
              return (
                <TabPane name={tab.value} label={tab.value === SpotOrderTabType.Current ? t(tab.label) + `(${spotOrderListStore.currentOrderList?.length})` : t(tab.label)}>
                  {tab.value === SpotOrderTabType.Position && (
                    <div class="tab-content">
                      <LazyLoadingComponent>
                        <PositionList />
                      </LazyLoadingComponent>
                    </div>
                  )}
                  {tab.value === SpotOrderTabType.Current && (
                    <div class="tab-content">
                      <LazyLoadingComponent>
                        <CurrentOrderList currentSymbolId={klineStore.currentSymbolId} />
                      </LazyLoadingComponent>
                    </div>
                  )}
                </TabPane>
              )
            })}
          </Tabs>
        </div>
      </div>
    )
  },
})
